export enum EvaluationActionType {

  // Update
  UpdateEvaluation                          = 'UPDATE_EVALUATION',
  UpdateEvaluationCompleted                 = 'UPDATE_EVALUATION_COMPLETED',
  UpdateEvaluationFailed                    = 'UPDATE_EVALUATION_FAILED',

  // Load
  LoadEvaluations                           = 'LOAD_EVALUATIONS',
  LoadEvaluationsCompleted                  = 'LOAD_EVALUATIONS_COMPLETED',
  LoadEvaluationsFailed                     = 'LOAD_EVALUATIONS_FAILED',

  // Select
  SelectEvaluation                          = 'SELECT_EVALUATION',
  SelectEvaluationCompleted                 = 'SELECT_EVALUATION_COMPLETED',
  SelectEvaluationFailed                    = 'SELECT_EVALUATION_FAILED',

  // Load Current Evaluation
  LoadCurrentEvaluation                     = 'LOAD_CURRENT_EVALUATION',
  LoadCurrentEvaluationCompleted            = 'LOAD_CURRENT_EVALUATION_COMPLETED',
  LoadCurrentEvaluationFailed               = 'LOAD_CURRENT_EVALUATION_FAILED',

  // Update Current Evaluation
  UpdateCurrentEvaluation             = 'UPDATE_CURRENT_EVALUATION',
  UpdateCurrentEvaluationCompleted    = 'UPDATE_CURRENT_EVALUATION_COMPLETED',
  UpdateCurrentEvaluationFailed       = 'UPDATE_CURRENT_EVALUATION_FAILED',

  // Reset Current Evaluation
  ResetCurrentEvaluation              = 'RESET_CURRENT_EVALUATION',
  ResetCurrentEvaluationCompleted     = 'RESET_CURRENT_EVALUATION_COMPLETED',
  ResetCurrentEvaluationFailed        = 'RESET_CURRENT_EVALUATION_FAILED',

  // Update Current Evaluation Subject's Id
  UpdateCurrentEvaluationRelatedTaskCompleted = 'UPDATE_CURRENT_EVALUATION_RELATED_TASK_COMPLETED',

  // Add New Review Comment
  AddNewReviewComment                 = 'ADD_NEW_REVIEW_COMMENT',
  AddNewReviewCommentCompleted        = 'ADD_NEW_REVIEW_COMMENT_COMPLETED',
  AddNewReviewCommentFailed           = 'ADD_NEW_REVIEW_COMMENT_FAILED',

  // Update Review Comment
  UpdateReviewComment                 = 'UPDATE_REVIEW_COMMENT',
  UpdateReviewCommentCompleted        = 'UPDATE_REVIEW_COMMENT_COMPLETED',
  UpdateReviewCommentFailed           = 'UPDATE_REVIEW_COMMENT_FAILED',

  // Delete Review Comment
  DeleteReviewComment                 = 'DELETE_REVIEW_COMMENT',
  DeleteReviewCommentCompleted        = 'DELETE_REVIEW_COMMENT_COMPLETED',
  DeleteReviewCommentFailed           = 'DELETE_REVIEW_COMMENT_FAILED',

  // Equipment
  UpdateEquipmentRecommendations            = 'UPDATE_EQUIPMENT_RECOMMENDATIONS',
  UpdateEquipmentRecommendationsCompleted   = 'UPDATE_EQUIPMENT_RECOMMENDATIONS_COMPLETED',
  UpdateEquipmentRecommendationsFailed      = 'UPDATE_EQUIPMENT_RECOMMENDATIONS_FAILED',

  // Update Recommendations
  AddEvaluationRecommendations                        = 'ADD_RECOMMENDATIONS',
  AddEvaluationRecommendationsCompleted               = 'ADD_RECOMMENDATIONS_COMPLETED',
  AddEvaluationRecommendationsFailed                  = 'ADD_RECOMMENDATIONS_FAILED',


  // Update Recommendations
  UpdateEvaluationRecommendations                     = 'UPDATE_RECOMMENDATIONS',
  UpdateEvaluationRecommendationsCompleted            = 'UPDATE_RECOMMENDATIONS_COMPLETED',
  UpdateEvaluationRecommendationsFailed               = 'UPDATE_RECOMMENDATIONS_FAILED',

  // Remove Recommendations
  RemoveEvaluationRecommendations                     = 'REMOVE_RECOMMENDATIONS',
  RemoveEvaluationRecommendationsCompleted            = 'REMOVE_RECOMMENDATIONS_COMPLETED',
  RemoveRecommendationsFailed               = 'REMOVE_RECOMMENDATIONS_FAILED',
}
